import styled from 'styled-components';

export const MailHistoryContainerStyled = styled.div`
  .alert_card {
    display: flex;
    align-items: center;
    gap: 16px;
    margin-bottom: 1.25rem;
    padding: 16px 20px;
    border: 1px solid ${({ theme }) => theme.COLORS.BLUE_1};
    border-radius: 10px;
    background: linear-gradient(90deg, ${({ theme }) => theme.COLORS.BLUE_5} 0%, ${({ theme }) => theme.COLORS.WHITE_1} 100%);
    .alert_icon {
      flex-shrink: 0;
      width: 44px;
      height: 44px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      background: ${({ theme }) => theme.COLORS.BLUE_1};
      color: ${({ theme }) => theme.COLORS.BLUE_4};
    }
    .alert_body {
      flex: 1;
      min-width: 0;
    }
    .alert_title {
      margin-bottom: 6px;
      color: ${({ theme }) => theme.COLORS.BLUE_7};
      font-size: ${({ theme }) => theme.FONT.SIZE.S16};
      font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_MEDIUM};
    }
    .alert_meta {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      gap: 8px;
      font-size: ${({ theme }) => theme.FONT.SIZE.S12};
      font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_LIGHT};
    }
    .meta_chip {
      display: inline-flex;
      align-items: center;
      gap: 4px;
      padding: 3px 10px;
      border-radius: 12px;
      background: ${({ theme }) => theme.COLORS.WHITE_1};
      border: 1px solid ${({ theme }) => theme.COLORS.BLUE_1};
      color: ${({ theme }) => theme.COLORS.BLUE_3};
    }
    .btn_run {
      flex-shrink: 0;
      .btn {
        white-space: nowrap;
        column-gap: 6px;
        padding: 0.625rem 1.25rem;
        box-shadow: 0 2px 6px rgba(33, 111, 237, 0.25);
      }
    }
  }
  @media (max-width: ${({ theme }) => theme.SCREENS.LAPTOP}) {
    .alert_card {
      flex-wrap: wrap;
      .btn_run {
        width: 100%;
      }
    }
  }
  .filter_layout {
    margin-bottom: 1rem;
  }
  .confirm_modal {
    width: 420px;
    max-width: 90vw;
    padding: 28px 28px 24px;
    border-radius: 12px;
    background: ${({ theme }) => theme.COLORS.WHITE_1};
    text-align: center;
    .confirm_icon {
      width: 48px;
      height: 48px;
      margin: 0 auto 14px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      background: ${({ theme }) => theme.COLORS.BLUE_1};
      color: ${({ theme }) => theme.COLORS.BLUE_4};
    }
    .confirm_title {
      margin-bottom: 8px;
      color: ${({ theme }) => theme.COLORS.BLUE_7};
      font-size: ${({ theme }) => theme.FONT.SIZE.S18};
      font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_MEDIUM};
    }
    .confirm_desc {
      color: ${({ theme }) => theme.COLORS.BLUE_2};
      font-size: ${({ theme }) => theme.FONT.SIZE.S14};
      font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_LIGHT};
      line-height: 1.6;
    }
    .confirm_action {
      margin-top: 24px;
      display: flex;
      justify-content: center;
      column-gap: 12px;
      .btn_box {
        width: 140px;
      }
    }
  }
  .subject_cell {
    color: ${({ theme }) => theme.COLORS.BLUE_7};
  }
  .sub_text {
    font-size: 12px;
    color: ${({ theme }) => theme.COLORS.GRAY_2};
  }
  .status_badge {
    display: inline-block;
    padding: 2px 10px;
    border-radius: 10px;
    font-size: 12px;
    white-space: nowrap;
    background: ${({ theme }) => theme.COLORS.GRAY_1};
    color: ${({ theme }) => theme.COLORS.GRAY_2};
  }
  .status_success {
    background: #e3f4e3;
    color: ${({ theme }) => theme.COLORS.GREEN_1};
  }
  .status_fail {
    background: #fde4e4;
    color: #c62828;
  }
  .status_sending {
    background: #fff3dc;
    color: #b26a00;
  }
  .error_text {
    max-width: 260px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: #c62828;
    font-size: 13px;
  }
`;
